import { FlexBox } from "@brg/ui";
import styled, { css } from "styled-components";

export const Wrapper = styled.div`
    width: 100%;
    height: auto;
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    flex-flow: column;
    background-color: #f2f2f2;
    padding-bottom: 16px;
`;

export const SortingItem = styled(FlexBox)<{ isActive?: boolean }>`
    height: 46px;
    width: 100%;
    white-space: nowrap;
    padding: 12px 16px;
    justify-content: flex-start;
    place-items: center;
    color: #70706F;
    font-size: 17px;
    line-height: 22px;
    font-weight: 600;
    font-family: 'Inter';
    background-color: #f2f2f2;


    ${({ isActive }) => isActive && css`
        color: #151514;
    `};
    
`;import { FlexBox } from "@brg/ui";
import styled, { css } from "styled-components";

export const Wrapper = styled.div`
    width: 100%;
    height: auto;
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    flex-flow: column;
    background-color: #f2f2f2;
    padding-bottom: 16px;
`;

export const SortingItem = styled(FlexBox)<{ isActive?: boolean }>`
    height: 46px;
    width: 100%;
    white-space: nowrap;
    padding: 12px 16px;
    justify-content: flex-start;
    place-items: center;
    color: #70706F;
    font-size: 17px;
    line-height: 22px;
    font-weight: 600;
    font-family: 'Inter';
    background-color: #f2f2f2;


    ${({ isActive }) => isActive && css`
        color: #151514;
    `};
    
`;